import type { SVGProps } from 'react';

const SvgStarOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0.587L14.833 9.306L24 9.306L16.584 14.694L19.416 23.413L12 18.024L4.584 23.413L7.416 14.694L0 9.306L9.167 9.306L12 0.587Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgStarOutline;
